<template>
  <v-breadcrumbs large class="pl-0 sigfloBodySmall" divider="/" :items="breadcrumbs">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        class="cursor"
        :class="getBreadcrumbClass(item)"
        @click="item.disabled ? null : handleBreadcrumbClick(item)"
        ripple
        color="#7C40DC"
      >
        {{ item.text }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    data() {
      return {};
    },
    methods: {
      /**
       * Handles a breadcrumb click and executes action defined on item
       */
      handleBreadcrumbClick(item) {
        // Call the associated function
        if (!item.disabled && item.text != 'Projects') {
          this.openProject(this.configurator.currentProject.id);
        } else {
          this.navToProjectStart();
        }
      },
      /**
       * Returns the CSS class for a breadcrumb item based on its disabled state.
       *
       * @param {Object} item - The breadcrumb item.
       * @returns {string} The CSS class for the breadcrumb item.
       */
      getBreadcrumbClass(item) {
        return item.disabled ? 'textLink' : 'textMuted';
      }
    },
    computed: {
      ...mapState(['configurator']),
      breadcrumbs() {
        return [
          {
            text: 'Projects',
            disabled: false
          },
          {
            text: this.configurator.currentProject?.name,
            disabled: false
          },
          {
            text: this.configurator.currentSystem?.name,
            disabled: false
          },
          {
            text: this.configurator.currentSubsystem?.name,
            disabled: true
          }
        ];
      }
    }
  };
</script>

<style scoped>
  .cursor {
    cursor: pointer;
  }
</style>
